import {
  FormControl as FormControlMUI,
  FormHelperText as FormHelperTextMUI,
  InputLabel,
  MenuItem as MenuItemMUI,
  Select as SelectMUI,
  Typography,
  type InputBaseProps,
} from '@mui/material';
import { type FC } from 'react';
import { useIntl } from 'react-intl';

import type { MenuItem } from '@/types/formTypes';

interface MultiSelectProps {
  id?: string;
  label?: string;
  name: string;
  value: (string | number)[] | undefined;
  onChange: (value: (string | number)[]) => void;
  onBlur?: InputBaseProps['onBlur'];
  menuItems: MenuItem[];
  disabled?: boolean;
  helperText?: string;
}

export const MultiSelect: FC<MultiSelectProps> = ({
  id = '',
  label,
  name,
  value,
  onChange,
  onBlur,
  menuItems,
  disabled = false,
  helperText = '',
}) => {
  const intl = useIntl();
  const noSelectionLabel = intl.formatMessage({ id: 'noSelection' });
  const normalizedValue = Array.isArray(value) ? value : [];

  return (
    <FormControlMUI>
      <InputLabel shrink={false}>{label}</InputLabel>
      <SelectMUI
        multiple
        displayEmpty
        id={id || name}
        name={name}
        value={normalizedValue}
        onChange={e => {
          const selectedValue = e.target.value as (string | number)[];
          if (selectedValue.includes('')) {
            onChange([]);
          } else {
            onChange(selectedValue);
          }
        }}
        renderValue={selected => {
          if (selected.length === 0) {
            return <Typography>{noSelectionLabel}</Typography>;
          }

          return selected.join(', ');
        }}
        {...(onBlur && { onBlur })}
        label={label}
        disabled={disabled}
        variant='outlined'
      >
        <MenuItemMUI value=''>{noSelectionLabel}</MenuItemMUI>
        {menuItems.map(item => (
          <MenuItemMUI
            key={item.value}
            value={item.value}
          >
            {item.label}
          </MenuItemMUI>
        ))}
      </SelectMUI>
      {helperText && <FormHelperTextMUI>{helperText}</FormHelperTextMUI>}
    </FormControlMUI>
  );
};
